import React from 'react';
import { IonButton, IonText } from '@ionic/react';

import './OverlayLogin.css';

interface Overlay {
  title: string,
  text: string,
  img: string
}

const OverlayLogin: React.FC<Overlay> = ({ title, img, text }) => {
  return (
    <div className="ion-padding ion-text-center center-all">
      <img src={img} alt={title} className='illustration' />
      <IonText color="tertiary"><h2>{title}</h2></IonText>
      <p className="italic">{text}</p>
      <IonButton color='danger' expand='block' routerLink='/login'>Se connecter</IonButton>
    </div>
  );
};

export default OverlayLogin;
